/*
  Global Add-to-Cart Interceptor
  ------------------------------
  Problem: some buttons (e.g. third-party app "Quick Buy" buttons on
  product cards) are plain <form action="/cart/add"> submissions with
  no JavaScript handling. Because they're not wrapped in Dawn's
  <product-form> custom element, clicking them causes a full page
  navigation to /cart instead of opening the cart drawer.

  Fix: listen for ALL form submissions site-wide. If a form posts to
  /cart/add and is NOT already handled by <product-form> (which has
  its own AJAX handler), intercept it here: submit via fetch, then
  open/update the cart drawer — exactly like the native flow.

  Install: save as assets/global-atc-intercept.js and add
    <script src="{{ 'global-atc-intercept.js' | asset_url }}" defer="defer"></script>
  in layout/theme.liquid, right after the existing cart-drawer.js
  script tag.
*/
(function () {
  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Already handled natively by Dawn's <product-form> component — don't double-handle.
    if (form.closest('product-form')) return;

    // Only intercept forms that add to cart.
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    var cart = getCartElement();
    if (!cart) return; // no drawer/notification on this page — let it behave normally

    event.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var formData = new FormData(form);
    formData.append(
      'sections',
      cart.getSectionsToRender().map(function (section) {
        return section.id;
      })
    );
    formData.append('sections_url', window.location.pathname);

    if (typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error('Add to cart error:', response.description || response.message);
          if (submitBtn) submitBtn.disabled = false;
          return;
        }
        cart.renderContents(response);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
})();